import React, { useCallback, useEffect, useState } from "react";
import axiosInstance from "../../../config/axiosApi/axiosApi";
import APIs from "../../../Constants/apis";
import Select from "react-select";
import DropDownStyles, { DropDownStylesDark } from "../../../pages/staff/dropdownStyles";
import { useSelector } from "react-redux";

const CurrencySelector = ({
  value,
  onChange,
  placeholder = "Select Currency",
  isDisabled = false,
  isClearable = true,
  className = "",
  styles = null
}) => {
  const isDarkMode = useSelector((state) => state.appSettings?.appDarkMode);
  const [currencies, setCurrencies] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchCurrencies = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(APIs.GET_ALL_CURRENCIES);

      if (response.data && response.data.data) {
        const currencyOptions = response.data.data.map((currency) => ({
          value: currency.value ?? currency.Value ?? "",
          label: currency.text ?? currency.Text ?? currency.value ?? currency.Value ?? "",
        }));
        setCurrencies(currencyOptions);
      } else {
        // Fallback currencies if API fails
        const fallbackCurrencies = [
          { value: "USD", label: "US Dollar (USD)" },
          { value: "EUR", label: "Euro (EUR)" },
          { value: "GBP", label: "British Pound (GBP)" },
          { value: "AED", label: "UAE Dirham (AED)" },
          { value: "PKR", label: "Pakistani Rupee (PKR)" },
          { value: "INR", label: "Indian Rupee (INR)" },
          { value: "SAR", label: "Saudi Riyal (SAR)" },
        ];
        setCurrencies(fallbackCurrencies);
      }
    } catch (err) {
      console.error("Error fetching currencies:", err);
      // Fallback currencies on error
      const fallbackCurrencies = [
        { value: "USD", label: "US Dollar (USD)" },
        { value: "EUR", label: "Euro (EUR)" },
        { value: "GBP", label: "British Pound (GBP)" },
        { value: "AED", label: "UAE Dirham (AED)" },
        { value: "PKR", label: "Pakistani Rupee (PKR)" },
        { value: "INR", label: "Indian Rupee (INR)" },
        { value: "SAR", label: "Saudi Riyal (SAR)" },
      ];
      setCurrencies(fallbackCurrencies);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCurrencies();
  }, [fetchCurrencies]);

  const handleChange = (selectedOption) => {
    if (onChange) {
      onChange(selectedOption);
    }
  };

  const selectedCurrency = currencies.find(currency => currency.value === value) || null;

  return (
    <Select
      value={selectedCurrency}
      onChange={handleChange}
      options={currencies}
      styles={styles || (isDarkMode ? DropDownStylesDark : DropDownStyles)}
      placeholder={loading ? "Loading currencies..." : placeholder}
      isDisabled={isDisabled || loading}
      isClearable={isClearable}
      isLoading={loading}
      className={className}
      noOptionsMessage={() => "No currencies found"}
      loadingMessage={() => "Loading currencies..."}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      menuShouldBlockScroll={false}
      menuShouldScrollIntoView={false}
      closeMenuOnScroll={false}
    />
  );
};

export default CurrencySelector;
